import { FullSource } from '@/types/source';

export enum StreamingMode {
    LIVE = 'live',
    VOD = 'vod',
}

export enum StreamingStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    READY = 'ready',
    ERROR = 'error',
}

export interface UseStreamingModeOptions {
    source?: FullSource;
    startTime?: number;
    initialMode?: StreamingMode;
}

export interface StreamingTimeline {
    intervals: TimelineInterval[];
    earliest: number | null;
    latest: number | null;
    totalDuration: number | null;
}

export interface ParsedTimeBoundaries {
    earliestMilliseconds: number;
    latestMilliseconds: number;
    earliestSeconds: number;
    latestSeconds: number;
}

export interface TimelineInterval {
    begin: number;
    end: number;
}

export interface ViinexStorageData {
    storageService: string;
    viinexBaseUrl: string;
    boundaries: ParsedTimeBoundaries;
    intervals: TimelineInterval[];
    viinexSourceId: string;
}
